import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import MaterialTable from "material-table"
import { Grid, Button, makeStyles, TextField, Typography } from "@material-ui/core"
import Modal from "@material-ui/core/Modal"
import Backdrop from "@material-ui/core/Backdrop"
import Fade from "@material-ui/core/Fade"
import tableIcons from "../../utils/helper"
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined"
import * as locationGroupActions from "../../actions/locationGroupActions"
import LocationGroupSummary from "./LocationGroupSummary"

const MaterialTableDemo = () => {
  const _ = require("lodash")
  const classes = useStyles()
  const dispatch = useDispatch()
  // const settings = useSelector(state => state.userInfo.settings)
  const userType = useSelector(state => _.get(state, "userInfo.settings.user.userType", ""))
  const auth = useSelector(state => ({ ...state.auth }))
  const [selectedRow, setSelectedRow] = React.useState(null)
  const serviceLocationGroups = useSelector(state => _.get(state, "locationGroups.data", []))
  const locations = useSelector(state => _.get(state, "userInfo.settings.locations", []))
  const isLoading = useSelector((state) => state.locationGroups.isFetching)
  const [locationGroupState, setLocationGroupState] = React.useState([])
  const [pageLoad, setPageLoad] = React.useState(false)
  const [open, setOpen] = React.useState(false)
  const [newGroupName, setNewGroupName] = React.useState("")
  const [hiddenNameText, setHiddenNameText] = React.useState(true)
  const [duplicateRow, setDuplicateRow] = React.useState()

  function handleOnCheck(event) {
    var locGroup = null
    let locationGroupIndex = _.findIndex(locationGroupState[selectedRow.tableData.id].locations.allowed, {
      name: event.target.value
    })
    let locationIndex = _.findIndex(locations, {
      name: event.target.value
    })

    // If not found in itGroup then push the given itCode into the array
    if (locationGroupIndex == -1) {
      locGroup = _.cloneDeep(locationGroupState)
      locGroup[selectedRow.tableData.id].locations.push(locations[locationIndex])
      setLocationGroupState(locGroup)
    }
    // If found in the itGroup, then filter it out and return the new list
    else {
      locGroup = _.cloneDeep(locationGroupState)

      locGroup[selectedRow.tableData.id].locations = locGroup[selectedRow.tableData.id].locations.filter(function (el) {
        return el.name != event.target.value
      })

      setLocationGroupState(locGroup)
    }
  }

  function duplicateLocationGroup(rowData) {
    setDuplicateRow(rowData)
    setOpen(true)
  }

  function confirmDuplicate() {
    if (newGroupName) {
      setHiddenNameText(true)
      setOpen(false)
      const allowed = duplicateRow.locations.allowed.map(e => e.code);
      const locGroup = {
        name: newGroupName,
        locations: {
          allowed
        }
      }
      
      dispatch(locationGroupActions.createLocationGroup({ token: auth.token }, locGroup))
    } else {
      setHiddenNameText(false)
    }
  }

  function typeNewGroupName(name) {
    setNewGroupName(name)
  }

  useEffect(() => {
    if (pageLoad === false) {
      dispatch(locationGroupActions.getLocationGroups({ token: auth.token }))
      setPageLoad(true)
      // setSelectedRow({
      //   tableData: { id: 0 }
      // })
    }
  }, [])

  useEffect(() => {
    if(!_.isEmpty(serviceLocationGroups )) {
      
    setLocationGroupState(serviceLocationGroups)
    }
  }, [serviceLocationGroups])

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <React.Fragment>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <h2 id="transition-modal-title">Duplicate Group</h2>
            <TextField
              id="dayExtend"
              name="dayExtend"
              label="Group Name"
              margin="dense"
              variant="outlined"
              value={newGroupName}
              onChange={e => typeNewGroupName(e.target.value)}
              type="text"
              fullWidth
            ></TextField>
            <Typography id="requiredNameText" style={{ fontSize: 13, marginLeft: 2, color: "red" }} hidden={hiddenNameText}>
              * Name is required
            </Typography>
            <Grid container alignItems="center" justify="center" style={{ marginTop: 20 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleClose}
                style={{
                  minWidth: 100,
                  margin: 5
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={confirmDuplicate}
                style={{
                  minWidth: 100,
                  margin: 5
                }}
              //onClick={confirmExtension}
              >
                Confirm
              </Button>
            </Grid>
          </div>
        </Fade>
      </Modal>
      <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
        <Grid item xs={5} lg={7}>
          <MaterialTable
            icons={tableIcons}
            title="Location Groups"
            columns={[
              { title: "Location Group", field: "name" }
              // { title: "active", field: "active" }
              // { title: "ID", field: "id", hidden: "true" }
              /* { title: 'Allowed', field: 'allowed' , type: 'boolean'}, */
            ]}
            options={{
              minBodyHeight: "calc(100vh - 224px)",
              maxBodyHeight: "calc(100vh - 224px)",
              pageSize: 20,
              rowStyle: rowData => ({
                backgroundColor: selectedRow && selectedRow.tableData.id === rowData.tableData.id ? "#EEE" : "#FFF",
                color: locationGroupState && rowData && rowData.active ? "black" : "lightgrey"
              })
            }}
            data={locationGroupState ? locationGroupState.map(x => Object.assign({}, x)) : []}
            onRowClick={(event, selectedRow) => {
              //console.log({currentSelectedRow:  selectedRow})
              setSelectedRow(undefined)
              setSelectedRow(selectedRow)
              //console.log({changedRow:  selectedRow})
            }}
            editable={{
              isAddable: () => userType == "ADMIN" || userType == "SERVICE_MANAGER",
              isDeletable: () => userType == "ADMIN" || userType == "SERVICE_MANAGER",
              isEditable: rowData => (rowData.active == true && userType == "ADMIN") || (rowData.active == true && userType == "SERVICE_MANAGER"),
              onRowAdd: newData =>
                new Promise(resolve => {
                  setTimeout(() => {
                    {
                      const locGroup = {
                        name: newData.name,
                        locations: {
                          allowed: [],
                          denied: []
                        }
                      }
                      dispatch(locationGroupActions.createLocationGroup({ token: auth.token }, locGroup))
                    }
                    resolve()
                  }, 1000)
                }),
              // onRowUpdate: newData =>
              //   new Promise(resolve => {
              //     setTimeout(() => {
              //       {
              //         let itGroup = newData
              //         dispatch(
              //           userInfoActions.setItGroup(
              //             { token: auth.token },
              //             itGroup
              //           )
              //         )
              //       }
              //       resolve()
              //     }, 1000)
              //   }),
              onRowDelete: oldData =>
                new Promise(resolve => {
                  setTimeout(() => {
                    {
                      setSelectedRow(null)
                      dispatch(locationGroupActions.deleteLocationGroup({ token: auth.token }, oldData))
                    }
                    resolve()
                  }, 1000)
                })
            }}
            isLoading={isLoading}
            actions={[
              {
                // eslint-disable-next-line react/display-name
                icon: () => <FileCopyOutlinedIcon />,
                tooltip: "Duplicate",
                onClick: (event, rowData) => {
                  duplicateLocationGroup(rowData)
                }
              }
            ]}
          />
        </Grid>
        {selectedRow && <LocationGroupSummary
          selectedRow={selectedRow}
          handleOnCheck={handleOnCheck}
          locationGroups={locationGroupState}
          locations={locations}
          setSelectedRow={setSelectedRow}
        />}
      </Grid>
    </React.Fragment>
  )
}

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles(theme => ({
  root: {
    "& button.MuiButtonBase-root": {
      padding: "5px"
    }
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  modalTextField: {
    width: 80,
    marginTop: 0,
    marginLeft: 10,
    padding: 0
  },
  textField: {
    "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      display: "none"
    },
    "& .MuiInputBase-input": {
      textAlign: "center"
    },
    maxWidth: 300
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    "&:focus": {
      outlineColor: "transparent"
    },
    borderRadius: 3,
    minHeight: 175,
    minWidth: 500
  },
  noFocus: {
    "&:focus": {
      outlineColor: "transparent"
    }
  }
}))

export default MaterialTableDemo
